import { ResponseUserProfile } from '@bessemercws/graphql';

export const mapTermsObservables = (user: ResponseUserProfile | undefined) => ({
  hasMobileCheckDeposit: user?.hasMobileCheckDeposit?.toString() || '',
  ACLACSDocument: user?.ACLACSDocument?.toString() || '',
  ACLAIDocument: user?.ACLAIDocument?.toString() || '',
  ACLAccount: user?.ACLAccount?.toString() || '',
  ACLBPDocument: user?.ACLBPDocument?.toString() || '',
  ACLIPSDocument: user?.ACLIPSDocument?.toString() || '',
  ACLTaxDocument: user?.ACLTaxDocument?.toString() || '',
  ACLYESDocument: user?.ACLYESDocument?.toString() || '',
  hasACSDocuments: user?.hasACSDocuments?.toString() || '',
  hasBillPayDocuments: user?.hasBillPayDocuments?.toString() || '',
  hasIPSDocuments: user?.hasIPSDocuments?.toString() || '',
  hasYESDocuments: user?.hasYESDocuments?.toString() || '',
  hasConsolidatedReporting: JSON.parse(user?.blackDiamondEligible || ''),
});
